export const getOfferTransitions = () => {
  return {
    //Offers transitions
    TRANSITION_SEND_OFFER: 'transition/send-offer',
    TRANSITION_ACCEPT_OFFER: 'transition/accept-offer',
    TRANSITION_DECLINE_OFFER: 'transition/decline-offer',
    TRANSITION_COUNTER_OFFER: 'transition/counter-offer',
    TRANSITION_ACCEPT_AFTER_COUNTER_1: 'transition/accept-after-counter-1',
    TRANSITION_DECLINE_AFTER_COUNTER_1: 'transition/decline-after-counter-1',
    TRANSITION_COUNTER_AFTER_COUNTER_1: 'transition/counter-after-counter-1',
    TRANSITION_ACCEPT_AFTER_COUNTER_2: 'transition/accept-after-counter-2',
    TRANSITION_DECLINE_AFTER_COUNTER_2: 'transition/decline-after-counter-2',
    TRANSITION_COUNTER_AFTER_COUNTER_2: 'transition/counter-after-counter-2',
    TRANSITION_ACCEPT_AFTER_COUNTER_3: 'transition/accept-after-counter-3',
    TRANSITION_DECLINE_AFTER_COUNTER_3: 'transition/decline-after-counter-3',
    TRANSITION_REQUEST_PAYMENT_AFTER_OFFER_ACCEPTED:
      'transition/request-payment-after-offer-accepted',
  };
};

export const getOfferExpiredTransitions = () => {
  return {
    //Offers transitions
    OFFER_EXPIRED: 'transition/offer-expired',
  };
};
export const getBidsTransitions = () => {
  return {
    //Offers transitions
    PLACE_BID: 'transition/place-bid',
    UPDATE_BID: 'transition/update-bid',
    UPDATE_BID_INFO: 'transition/update-bid-info',
    INITIATE_BID_PAYMENT_OPERATOR: 'transition/initiate-bid-payment-operator',
    INITIATE_BID_PAYMENT: 'transition/initiate-bid-payment',
    BID_PAYMENT_EXPIRE: 'transition/bid-payment-expire',
    TRANSFER_BID: 'transition/transfer-bid',
    REQUEST_PAYMENT_AFTER_BID_PLACED: 'transition/request-payment-after-bid-placed',
    REQUEST_PAYMENT_AFTER_BID_TRANSFER: 'transition/request-payment-after-bid-transfer',
  };
};

export const determineRequestTransition = (lastTransition, isOffers, isBuyNow, process) => {
  if (lastTransition === process.transitions.INQUIRE || isOffers) {
    return process.transitions.REQUEST_PAYMENT_AFTER_INQUIRY;
  }
  if (isBuyNow) {
    return process.transitions.REQUEST_PAYMENT;
  }
  if (lastTransition === process.transitions.TRANSFER_BID) {
    return process.transitions.REQUEST_PAYMENT_AFTER_BID_TRANSFER;
  }
  return process.transitions.REQUEST_PAYMENT_AFTER_BID_PLACED;
};
